/* Errors constants */
export const Errors = {
        NO_MAP_FOUND: "NOMAPFOUND",
        NO_ADDRESS_FOUND: "NOADDRESSFOUND",
        NO_GEOLOCATION: "NOGEOLOCATION",
        NO_LOCATION: "NOLOCATION"
}

export const AddressType = {
        Fixed: "_fixed_",
        PointOnMap: "_point_on_map_",
        Generic: "_generic_"
}